import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-col bg-white p-10 max-sm:p-5 lg:w-97.5 xl:w-105',
    product: 'mb-6',
    recommendPercent: 'mb-8',
    action: 'mb-10',
    actionButton: 'w-full sm:w-100 lg:w-full',
    rating: 'mb-3 justify-start'
  }
});
